export default __webpack_public_path__ + "static/media/image (3).fd95ce8e.png";